document.addEventListener("DOMContentLoaded", () => {
  // Select all input elements within .form-field.newsletter-input
  const inputs = document.querySelectorAll(
    ".form-field.newsletter-input .form-field-input"
  );

  inputs.forEach((input) => {
    // Function to toggle 'hidden' class on the label
    const toggleHiddenClass = () => {
      const siblingLabel =
        input.parentElement.querySelector(".form-field-title");
      if (input.value.trim() !== "") {
        siblingLabel?.classList.add("hidden");
      } else {
        siblingLabel?.classList.remove("hidden");
      }
    };

    // Listen for input event to detect typing
    input.addEventListener("input", toggleHiddenClass);

    // Initial check in case the input already has a value
    toggleHiddenClass();
  });
});


/* Header Highlights */
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(
    "#header-highlights .highlight-single"
  );
  
  if (!items.length) {
    return;
  }

  let currentIndex = 0;

  const updateSlides = () => {
    items.forEach((item, index) => {
      item.classList.remove("active");
      if (index === currentIndex) {
        item.classList.add("active");
      }
    });
  };

  const nextSlide = () => {
    currentIndex = (currentIndex + 1) % items.length;
    updateSlides();
  };

  updateSlides();

  setInterval(nextSlide, 1500);
});


/* Blog Posts Section - Flickity */
document.addEventListener("DOMContentLoaded", function () {
  const blogPostsContainer = document.querySelector(".blogposts--inner");

  if (!blogPostsContainer) {
    return;
  }

  if (blogPostsContainer.hasAttribute("data-blog-posts")) {
    return;
  }

  let flickityInstance = null;

  // Function to initialize Flickity
  const initializeFlickity = () => {
    if (flickityInstance) return; // Prevent re-initialization
    if (typeof Flickity === "undefined") return;

    flickityInstance = new Flickity(blogPostsContainer, {
      cellSelector: ".article--excerpt-wrapper",
      groupCells: 1,
      wrapAround: true,
      pageDots: true,
      contain: true,
      autoPlay: 5000,
      accessibility: true,
      arrowShape:
        "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
    });

    console.log("Flickity initialized for mobile/tablet.");
  };

  // Function to destroy Flickity
  const destroyFlickity = () => {
    if (flickityInstance) {
      flickityInstance.destroy();
      flickityInstance = null;
      console.log("Flickity destroyed.");
    }
  };

  // Function to check screen size and toggle Flickity
  const handleScreenSize = () => {
    const isMobileOrTablet = window.innerWidth < 1024;

    if (isMobileOrTablet) {
      initializeFlickity();
    } else {
      destroyFlickity();
    }
  };

  // Run on page load
  handleScreenSize();

  // Run on window resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleScreenSize, 300); // Debounce resize
  });
});


/* Faceted Filters */
function initPriceRangeSlider(root) {
  const scope = root || document;

  const sliderContainer = scope.querySelector("[data-filter-group-range]");
  const inputMin = scope.querySelector("input[name='filter.v.price.gte']");
  const inputMax = scope.querySelector("input[name='filter.v.price.lte']");

  if (!sliderContainer || !inputMin || !inputMax) {
    return;
  }

  if (typeof noUiSlider === "undefined") {
    console.warn("noUiSlider is not available.");
    return;
  }

  let slider = sliderContainer.querySelector("#price-range-slider");

  if (slider && slider.noUiSlider) {
    return;
  }

  if (!slider) {
    slider = document.createElement("div");
    slider.id = "price-range-slider";
    sliderContainer.prepend(slider);
  }

  const minValue = parseInt(inputMin.value || inputMin.min || 0, 10);
  const maxValue = parseInt(inputMax.value || inputMax.max || 0, 10);
  const rangeMin = parseInt(inputMin.min || 0, 10);
  const rangeMax = parseInt(inputMax.max || 0, 10);

  noUiSlider.create(slider, {
    start: [minValue, maxValue],
    connect: true,
    range: {
      min: rangeMin,
      max: rangeMax
    }
  });

  slider.noUiSlider.on("update", function (values) {
    inputMin.value = Math.round(values[0]);
    inputMax.value = Math.round(values[1]);
  });

  inputMin.addEventListener("change", function () {
    if (slider.noUiSlider) {
      slider.noUiSlider.set([this.value || rangeMin, null]);
    }
  });

  inputMax.addEventListener("change", function () {
    if (slider.noUiSlider) {
      slider.noUiSlider.set([null, this.value || rangeMax]);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initPriceRangeSlider(document);
});

document.addEventListener("shopify:section:load", function (event) {
  initPriceRangeSlider(event.target);
});


/* Collection Bottom Description */

document.addEventListener("DOMContentLoaded", () => {
  // Select all sections with the rich-text class
  const sections = document.querySelectorAll(
    "section.collection-bottom-description"
  );

  sections.forEach((section) => {
    // Find the container where the h3 and other elements are located
    const richTextContent = section.querySelector(".rich-text-content.rte");

    if (richTextContent) {
      // Query all h3 elements within this container
      const h3Elements = richTextContent.querySelectorAll("h3");

      h3Elements.forEach((h3) => {
        const wrapper = document.createElement("div");
        wrapper.className = "desc-block";

        // Append the current h3 to the wrapper
        wrapper.appendChild(h3.cloneNode(true));

        let nextElement = h3.nextElementSibling;

        // Collect all sibling elements until the next h3 or h2
        while (
          nextElement &&
          !["H3", "H2"].includes(nextElement.tagName.toUpperCase())
        ) {
          wrapper.appendChild(nextElement.cloneNode(true));
          const temp = nextElement.nextElementSibling; // Store reference to the next element
          nextElement.remove(); // Remove the element after cloning
          nextElement = temp; // Update to the next sibling
        }

        // Replace the original h3 with the wrapper
        h3.replaceWith(wrapper);
      });
    }
  });
});

/* Collection FAQs */

document.addEventListener("DOMContentLoaded", () => {
  // Select all sections with the collection-faqs class
  const faqSections = document.querySelectorAll("section.collection-faqs");

  faqSections.forEach((section) => {
    // Find the container where the h3 and other elements are located
    const richTextContent = section.querySelector(".rich-text-content.rte");

    if (richTextContent) {
      // Query all h3 elements within this container
      const h3Elements = richTextContent.querySelectorAll("h3");

      h3Elements.forEach((h3) => {
        const wrapper = document.createElement("div");
        wrapper.className = "faq-single";

        // Append the current h3 to the wrapper
        wrapper.appendChild(h3.cloneNode(true));

        let nextElement = h3.nextElementSibling;

        // Collect all sibling elements until the next h3 or h2
        while (
          nextElement &&
          !["H3", "H2"].includes(nextElement.tagName.toUpperCase())
        ) {
          wrapper.appendChild(nextElement.cloneNode(true));
          const temp = nextElement.nextElementSibling; // Store reference to the next element
          nextElement.remove(); // Remove the element after cloning
          nextElement = temp; // Update to the next sibling
        }

        // Replace the original h3 with the wrapper
        h3.replaceWith(wrapper);
      });
    }
  });
});


/* Blogs */